import {
  Home, ShoppingBag, ClipboardList, BookOpen, MessageSquare, UserCheck, MapPin, CreditCard, User, Lock,
  HelpCircle, Trophy, Receipt, CalendarDays, Users, FileText, Flag,
} from 'lucide-react';
import { useMenu, VOCI_ALLENATORE } from './menuStaff';

// Menu dei portali Utenti e Allenatori riordinabili da ROOT (Impostazioni → Menu laterale, 23/10/2026):
// solo ordine e nomi, niente menu a gruppi. Accese/spente restano in Impostazioni → Ruoli
// (vociPortale.js), "Diventa socio" sparisce sempre per chi è già socio.
export const VOCI_UTENTE = [
  { path:'/cliente',          label:'HOME',            icon:Home },
  { path:'/cliente/catalogo', label:'CATALOGO',        icon:BookOpen },
  { path:'/cliente/ordine',   label:'NUOVO ORDINE',    icon:ShoppingBag },
  { path:'/cliente/ordini',   label:'I MIEI ORDINI',   icon:ClipboardList },
  { path:'/cliente/campi',    label:'AFFITTO CAMPO',   icon:MapPin },
  { path:'/cliente/fipav',    label:'FIPAV',           icon:Trophy },
  { path:'/cliente/aibvc',    label:'AIBVC',           icon:Flag },
  { path:'/cliente/tessera',  label:'LA MIA TESSERA',  icon:CreditCard },
  { path:'/cliente/ricevute', label:'LE MIE RICEVUTE', icon:Receipt },
  { path:'/cliente/profilo',  label:'IL MIO PROFILO',  icon:User },
  { path:'/cliente/cambia-password', label:'CAMBIA PASSWORD', icon:Lock },
  { path:'/cliente/tickets',  label:'SUPPORTO',        icon:MessageSquare },
  { path:'/cliente/guida',    label:'GUIDA',           icon:HelpCircle },
  { path:'/cliente/socio',    label:'DIVENTA SOCIO',   icon:UserCheck, hideIfSocio:true },
];

export const VOCI_PORTALE_ALLENATORE = [
  { path:'/allenatore',            label:'LE MIE PRESENZE',  icon:CalendarDays },
  { path:'/allenatore/contratti',  label:'I MIEI CONTRATTI', icon:FileText },
  { path:'/allenatore/documenti',  label:'I MIEI DOCUMENTI', icon:FileText },
  { path:'/allenatore/anagrafica', label:'I MIEI DATI',      icon:UserCheck },
  { path:'/cliente/tessera',       label:'LA MIA TESSERA',   icon:CreditCard },
  { path:'/calendario-allenatori', label:'CALENDARIO ALLENATORI', icon:Users },
  { path:'/allenatore/rimborsi',   label:'I MIEI RIMBORSI',  icon:Receipt },
  { path:'/cliente',          label:'HOME CLIENTE',  icon:Home },
  { path:'/cliente/catalogo', label:'CATALOGO',      icon:BookOpen },
  { path:'/cliente/ordine',   label:'NUOVO ORDINE',  icon:ShoppingBag },
  { path:'/cliente/ordini',   label:'I MIEI ORDINI', icon:ClipboardList },
  { path:'/cliente/campi',    label:'AFFITTO CAMPO', icon:MapPin },
  { path:'/cliente/fipav',    label:'FIPAV',         icon:Trophy },
  { path:'/cliente/aibvc',    label:'AIBVC',         icon:Flag },
  { path:'/cliente/ricevute', label:'LE MIE RICEVUTE', icon:Receipt },
  { path:'/cliente/tickets',  label:'SUPPORTO',      icon:MessageSquare },
  { path:'/cliente/cambia-password', label:'CAMBIA PASSWORD', icon:Lock },
  { path:'/allenatore/guida', label:'GUIDA ALLENATORI', icon:HelpCircle },
  { path:'/cliente/guida',    label:'GUIDA UTENTI',  icon:HelpCircle },
  { path:'/cliente/socio',    label:'DIVENTA SOCIO', icon:UserCheck, hideIfSocio:true },
];

const NOME_PORTALE_ALLENATORE = Object.fromEntries(VOCI_PORTALE_ALLENATORE.map(v => [v.path, v.label]));

export const CATALOGO_PORTALE ={ UTENTE: VOCI_UTENTE, ALLENATORE: VOCI_PORTALE_ALLENATORE };

// Catalogo + layout salvato → voci in ordine con i nomi scelti. Voci sconosciute tolte; una voce
// nuova non ancora sistemata va subito dopo quella che la precede nel catalogo (o in cima).
export const ordinaVociPortale = (catalogo, layout) => {
  const perPath = Object.fromEntries(catalogo.map(v => [v.path, v]));
  const ordine = [];
  for (const v of layout?.voci || []) if (v.tipo === 'voce' && perPath[v.path] && !ordine.includes(v.path)) ordine.push(v.path);
  catalogo.forEach((v, i) => {
    if (ordine.includes(v.path)) return;
    const prima = i > 0 ? ordine.indexOf(catalogo[i - 1].path) : -1;
    ordine.splice(prima + 1, 0, v.path);
  });
  const nomi = layout?.nomi || {};
  return ordine.map(p => ({ ...perPath[p], label: nomi[p] || perPath[p].label }));
};

export const useVociPortaleOrdinate = (ambito) => ordinaVociPortale(CATALOGO_PORTALE[ambito], useMenu(ambito));

// Staff in modalità allenatore: stesso ordine e stessi nomi del menu del portale allenatori
export const useVociAllenatoreStaff = () => {
  const layout = useMenu('ALLENATORE');
  const ordine = ordinaVociPortale(VOCI_PORTALE_ALLENATORE, layout).map(v => v.path);
  return [...VOCI_ALLENATORE]
    .sort((a, b) => ordine.indexOf(a.portale) - ordine.indexOf(b.portale))
    // Nome di base = quello del portale allenatori (come lo mostra l'editor), non quello scritto qui:
    // prima "LA MIA SQUADRA AIBVC"/"TORNEI FIPAV" restavano anche rinominando (02/11/2026).
    .map(v => ({ ...v, label: layout?.nomi?.[v.portale] || NOME_PORTALE_ALLENATORE[v.portale] || v.label }));
};
